import React from "react"
import Typing from "react-typing-animation"
import { Link } from "gatsby"
import { BsArrowRight } from "react-icons/bs"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ClientStart from "../components/ClientStart/ClientStart"
import aws_partner_badge from "../../static/images/aws_partner_badge.png"
const CustomersPartnersPage = () => (
  <Layout>
    <SEO
      title="Customers &amp; Partners"
      description="Find out who we are working with. We have helped a number of orginisations across multiple industries adopt Cloud and Devops. We Always put our customers first."
    />
    <div class="hero-section d-section">
      <div class="hero-wrapper other">
        <div class="hero-container">
          <div class="hero-content">
            <h1 class="hero-h1">Customers & Partners</h1>
            <Typing speed={2}>
              <p class="hero-p">
                Find out who we are working with. We have helped a number of
                organisations across multiple industries adopt Cloud and Devops.
                We Always put our customers first.
              </p>
            </Typing>
          </div>
        </div>
      </div>
    </div>
    <div class="section border-bottom-0">
      <div class="container">
        <div className="row">
          <div className="col-md-9">
            <h2 class="section-title">Customers</h2>
            <div class="d-flex flex-wrap clients-cards">
              <div class="content _30">
                <div class="card">
                  <img src="/images/clients/3line.png" alt="3line" />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img src="/images/clients/sidmach.png" alt="sidmach" />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img src="/images/clients/sterling.png" alt="sterling" />
                </div>
              </div>

              <div class="content _30">
                <div class="card">
                  <img src="/images/clients/db.png" alt="deutch bank logo" />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                    src="/images/clients/atlantic.png"
                    alt="atlantic oil & gas"
                  />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                    src="/images/clients/landrover.png"
                    alt="Jaguar landrover"
                  />
                </div>
              </div>

              <div class="content _30">
                <div class="card">
                  <img src="/images/clients/adimo2.png" alt="Adimo" />
                </div>
              </div>

              <div class="content _30">
                <div class="card">
                  <img
                  
                    src="/images/clients/SCT-logo.png"
                    alt="Smart Components Tech"
                  />
                </div>
              </div>

              <div class="content _30">
                <div class="card" >
                  <img src="/images/clients/world-logo.png" alt="WorldBay Tech" />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                  
                    src="/images/clients/NHS_logo.png"
                    alt="NHS"
                  />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                  
                    src="/images/clients/chetwood.png"
                    alt="Cheetwood Financial"
                  />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                  
                    src="/images/clients/Roche-logo.png"
                    alt="Roche"
                  />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                  
                    src="/images/clients/megger_Logo.png"
                    alt="Megger"
                  />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                  
                    src="/images/agileadvisor.jpeg"
                    alt="Megger"
                  />
                </div>
              </div>
              <div class="content _30">
                <div class="card">
                  <img
                  
                    src="/images/jk_logo.png"
                    alt="Megger"
                  />
                </div>
              </div>
              
              
            </div>
          </div>

          <div className="col-md-3">
            <h2 class="section-title ptn-t">Partners</h2>
            <div className="clients-cards pt-cards">
            <div className="content">
                  <a href="https://partners.amazonaws.com/partners/0010h00001d5BJOAA2/" target="_blank">
                    <img src={aws_partner_badge} alt="AWS Partner badge" />
                  </a>

                  <Link to="/partners/aws" className="cta">
                    Read about our AWS Services{" "}
                    <span>
                      <BsArrowRight />
                    </span>
                  </Link>
                </div>

              {/* <div className="content">
                <div class="card">
                  <a href="https://theagileadvisor.com">
                    <img
                      // style={{ maxHeight: "80px" }}
                      src="/images/agileadvisor.jpeg"
                      alt=""
                    />
                  </a> 
                  <h3 class="feature-title">The Agile Advisor Africa</h3>
              <p class="p16">
                Head Office
                <br />
                Church House - 5th Floor
                <br />
                29 Marina Street
                <br />
                Lagos, Nigeria
                <br />
                +234 814 727 0598
                <a href="mailto:info@theagileadvisor.com" class="p16">
                  <br />
                  info@theagileadvisor.com
                </a>
              </p> 
                </div>
              </div> */}

              {/* <div className="content">
                <div class="card">
                  <a href="https://jakeriley.org/">
                    <img
                      style={{ maxHeight: "80px" }}
                      src="/images/jk_logo.png"
                      alt=""
                    />
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ClientStart />
  </Layout>
)

export default CustomersPartnersPage
